import { useAuthStore } from '~/store/authStore'

export default defineNuxtRouteMiddleware((to, _) => {
  const authStore = useAuthStore()

  if (import.meta.server) return

  if (!to.path.startsWith('/tablet') && authStore.tabletMode) {
    return navigateTo('/tablet')
  }
})
